import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const SamlIntegrationSetupResponseSchema = z.object({
    spEntityId: z.string(),
    assertionConsumer: z.string(),
});
export class SamlIntegrationSetupResponseDto extends createZodDto(SamlIntegrationSetupResponseSchema) {
}
